
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { TaskActionType } from 'enums/TaskActionType';
import { Model, ModelProperty } from 'models/Model';


export class CreateTaskActionWithNewTaskflowRequestModel extends Model<CreateTaskActionWithNewTaskflowRequestModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'logComments', type: 'string' },
		{ name: 'logEntryStatus', type: 'string' },
		{ name: 'followUpDate', type: 'Date' },
		{ name: 'followUpTaskType', type: 'TaskActionType' },
		{ name: 'taskflowTag', type: 'string' },
		{ name: 'companyId', type: 'string' },
		{ name: 'dateOnly', type: 'boolean' },
		{ name: 'mailData', type: 'string' }
	];
	[key: string]: any;
	
	public logComments: string;
	public logEntryStatus?: string;
	public followUpDate?: Date;
	public followUpTaskType: TaskActionType;
	public taskflowTag: string;
	public companyId?: string;
	public dateOnly: boolean;
	public mailData: string;
    
	constructor(){
		super();
		this.logComments = '';
		this.logEntryStatus = undefined;
		this.followUpDate = undefined;
		this.followUpTaskType = 0;
		this.taskflowTag = '';
		this.companyId = undefined;
		this.dateOnly = false;
		this.mailData = '';
		
	}
	getProperties(){
		return CreateTaskActionWithNewTaskflowRequestModel.classProperties;
	}
}

